const geoUrl = arr => 'https://www.google.com/maps/place/' + arr;

export default geoUrl;
